import { Chain } from 'viem';
import { arbitrum, base, mainnet, polygon } from 'viem/chains';

import { SUPPORTED_CHAIN_IDS } from './config.types';

export const ALCHEMY_API_KEY = import.meta.env.VITE_ALCHEMY_API_KEY;

export const alchemyDomains: Record<SUPPORTED_CHAIN_IDS, string> = {
  [SUPPORTED_CHAIN_IDS.ARBITRUM]: 'arb-mainnet',
  [SUPPORTED_CHAIN_IDS.ETHEREUM]: 'eth-mainnet',
  [SUPPORTED_CHAIN_IDS.POLYGON]: 'polygon-mainnet',
  [SUPPORTED_CHAIN_IDS.BASE]: 'base-mainnet',
};

export const CHAINS_BY_ID: Record<number, Chain> = {
  [mainnet.id]: mainnet,
  [base.id]: base,
  [polygon.id]: polygon,
  [arbitrum.id]: arbitrum,
};

export const DEFAULT_CHAIN_ID = SUPPORTED_CHAIN_IDS.BASE;
export const DEFAULT_CHAIN = CHAINS_BY_ID[DEFAULT_CHAIN_ID] as Chain;
